module.exports = __webpack_public_path__ + "static/media/ManPetals.b5025ac2.png";